import { useNodeRef } from './useNodeRef';
import { useVariable } from './useVariable';
export const useClick = (onClick, initialRef, disabled = false) => {
  const handleClick = useVariable(disabled ? null : onClick);
  const [setRef, nodeRef] = useNodeRef(initialRef, node => {
    node.addEventListener('click', (...args) => handleClick.current?.(...args));
  });
  return {
    nodeRef,
    setRef
  };
};